import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ClimaCheckService from '~/api/services/climaCheck'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'

interface Props {
  planData: any
  handleClose: (submit?: boolean) => void
}

const PlanModal: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { planData, handleClose } = props

  const [isBusy, setIsBusy] = useState(false)

  function getTextContent() {
    const start = dayjs(planData?.start).format(('dddd, D MMMM YYYY HH:mm'))
    const end = dayjs(planData?.end).format(('dddd, D MMMM YYYY HH:mm'))
    return t('The data collection {{id}} for calculating GHG emissions starts on {{start}} and ends on {{end}} and is hereby planned. All farmers can view information regarding this data collection.', { id: planData?.uniqueId, start, end })
  }

  async function handlePlan() {
    setIsBusy(true)
    try {
      await ClimaCheckService.planClimaCheck(planData?.id)
      notify(t('The data collection for the Climate check emissions calculation was successfully planned.'), 'success')
      handleClose(true)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(planData)}
    disableSubmit={isBusy}
    isLoading={isBusy}
    handleClose={() => handleClose()}
    textHeader={t('Plan data collection for Climate check emissions calculation {{id}}', { id: planData?.uniqueId })}
    textContent={getTextContent()}
    textSubmit={t('Plan data collection')}
    style={{ width: 800 }}
    textClose={t('Cancel')}
    type={'abort'}
    handleSubmit={() => handlePlan()}
  />

}
export default PlanModal